<template>
    <div class="mt-10"> 
           <div class=" flex flex-col items-center py-2 "> 
              <!-- <p>  filename: {{filename}}</p> -->
                     
                    <a class=" px-4 py-4 bg-gray-700 border rounded-lg text-white  font-semibold" 
                            :href="filename"> DOWNLOAD HERE 
                            </a>
                
                    
            </div>
    </div>
</template>
<script>
export default {
    props:{
        filename:String
    }
}
</script>